import { Button, NumberField, SwitchField } from "@inmagik/magik-ui"
import { useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { Media, RecordMedia } from "../../types"
import { useCreateMedia, useMediaList } from "../../hooks/media"
import { ImageSelectField } from "../../components/ImageSelectField"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import MediaModal from "../Media/MediaModal"
import { transformErrorForForm } from "../../utils/utils"

export default function MediaDocumentForm({ col = 8 }: { col?: number; id: number | undefined }) {
  const { values, setFieldValue } = useFormikContext<RecordMedia & Media>()

  const { data: media } = useMediaList({
    page_size: String(1000),
  })

  const createMediaDocument = useCreateMedia()
  const [modalStateCreateMedia, modalActionsCreateMedia] = useModalTrigger()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      {/* select with image preview */}
      <ImageSelectField
        name="media"
        label="Seleziona Media"
        options={
          media?.results?.map((m) => ({
            id: m.id,
            image_url: String(m.media_file),
            title: m.title,
            thumbnail: m.thumbnail,
          })) || []
        }
        imageWidth={112}
        imageHeight={100}
        showTitle={true}
        emptyMessage="Nessuna media disponibile"
      />

      <Button
        size="md"
        title="Aggiungi nuovo media"
        leadingIcon="add"
        style={{ alignSelf: "start", width: "fit-content" }}
        onClick={() => {
          modalActionsCreateMedia.open()
        }}
      />

      <SwitchField
        label="Copertina"
        layout="horizontal"
        value={values.cover}
        onChange={(value) => {
          setFieldValue("cover", value)
        }}
      />

      <NumberField
        label="Ordine"
        layout="horizontal"
        value={values.order}
        onChange={(value) => {
          setFieldValue("order", value)
        }}
      />
      <MediaModal
        show={modalStateCreateMedia.isOpen}
        onClose={modalActionsCreateMedia.close}
        save={(valuesMedia, actions) => {
          return createMediaDocument
            .mutateAsync(valuesMedia)
            .then((media) => {
              setFieldValue("media", media.id)
              modalActionsCreateMedia.close()
            })
            .catch((e: any) => {
              actions.setErrors(transformErrorForForm(e))
            })
        }}
        title="Crea nuovo media"
      />
    </Col>
  )
}
